module.exports = __webpack_public_path__ + "img/bg-border.744bde2f.png";